import React from 'react'
import { PAYMENT_BADGES } from '../Utils/paymentConfig'
import { useLanguage } from '../Utils/LanguageContext'
import { getCheckoutCopy } from '../Utils/checkoutI18n'
import './PaymentMethods.css'

function MastercardIcon() {
  return (
    <span className="pay-badge__mc" aria-hidden="true">
      <i />
      <i />
    </span>
  )
}

/**
 * Accepted payment methods — synced with Moyasar + Tamara config.
 *
 * @param {{ variant?: 'default'|'compact'|'checkout'|'footer', showLabel?: boolean, showNote?: boolean, className?: string }} props
 */
export default function PaymentMethods({
  variant = 'default',
  showLabel = true,
  showNote = variant === 'checkout',
  className = '',
}) {
  const { isArabic } = useLanguage()
  const t = getCheckoutCopy(isArabic)

  return (
    <div
      className={`pay-methods pay-methods--${variant}${className ? ` ${className}` : ''}`}
      data-no-translate
    >
      {showLabel ? (
        <span className="pay-methods__label">{t.weAccept}</span>
      ) : null}
      <ul className="pay-methods__list" aria-label={t.weAccept}>
        {PAYMENT_BADGES.map((method) => (
          <li key={method.id}>
            <span
              className={`pay-badge ${method.className}`}
              title={method.title}
              aria-label={method.title}
            >
              {method.icon === 'mastercard' ? <MastercardIcon /> : method.label}
            </span>
          </li>
        ))}
      </ul>
      {showNote ? (
        <p className="pay-methods__note mb-0">{t.payNote}</p>
      ) : null}
    </div>
  )
}
